/**
 * Instant Coverage — Rebuy Smart Cart engine. Self-contained: a Rebuy store
 * pastes this instead of redo-instant.js, never both.
 */
(function () {
  "use strict";
  if (window.__redoInstantEngine) return;
  window.__redoInstantEngine = true;
  if (window.__redoInstantArm !== "instant") return;

  var NAV_TIMEOUT_MS = 4000;
  var PENDING_RESET_MS = 2000;
  var INJECTED_CLASS = "redo-instant-injected";
  var CART_WRITE = /\/cart\/(add|change|update|clear)/;
  var CART_ADD = /\/cart\/add/;

  var tpl = null;
  var cfg = null;
  // null = undetermined. Only a definite false suppresses the buttons.
  var eligible = null;
  var merchantCents = null;
  var verdicts = {};

  function postJson(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then(function (r) {
      if (!r.ok) throw new Error(url + " -> " + r.status);
      return r.json();
    });
  }

  /** Puts the DOM in sync with `eligible`; safe to call on every mutation. */
  function sync() {
    if (!tpl) return;
    var present = document.querySelector("[data-redo-instant]");
    if (eligible === false) {
      if (present) present.remove();
      document.documentElement.classList.remove(INJECTED_CLASS);
      return;
    }
    if (present && present.isConnected) return;
    var target = document.querySelector(cfg.injectAfter);
    if (!target) {
      log("no inject target yet:", cfg.injectAfter);
      document.documentElement.classList.remove(INJECTED_CLASS);
      return;
    }
    log("injecting after", cfg.injectAfter);
    target.parentNode.insertBefore(tpl.content.cloneNode(true), target.nextSibling);
    document.documentElement.classList.add(INJECTED_CLASS);
    updatePrice();
  }

  function updatePrice() {
    var el = document.querySelector("[data-redo-instant-price]");
    if (!el || merchantCents === null) return;
    var prefix = el.getAttribute("data-prefix");
    if (prefix === null) {
      prefix = el.textContent.replace(/[\d.,\s]+$/, "");
      el.setAttribute("data-prefix", prefix);
    }
    el.textContent = prefix + ((merchantCents + cfg.coverageCents) / 100).toFixed(2);
  }

  function log() {
    if (!window.__redoInstantDebug) return;
    console.log.apply(console, ["[instant-coverage]"].concat([].slice.call(arguments)));
  }

  function tagsExclude(tags) {
    for (var i = 0; i < (tags || []).length; i++) {
      if (cfg.excludeTags.indexOf("," + String(tags[i]).toLowerCase().trim() + ",") !== -1) {
        return true;
      }
    }
    return false;
  }

  /** /cart.js carries no tags, so unknown handles are looked up once and cached. */
  function resolveExclusion(handle) {
    if (handle in verdicts) return Promise.resolve(verdicts[handle]);
    return fetch("/products/" + handle + ".js")
      .then(function (r) { return r.json(); })
      .then(function (p) {
        verdicts[handle] = tagsExclude(p.tags);
        log(verdicts[handle] ? "excluded" : "eligible", handle, "tags:", p.tags);
        return verdicts[handle];
      })
      .catch(function () {
        // Unknown tags: treat as eligible rather than hiding coverage wrongly.
        verdicts[handle] = false;
        log("lookup failed, assuming eligible:", handle);
        return false;
      });
  }

  /** Coverage needs at least one non-excluded item in the cart. */
  function refreshCart() {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items.filter(function (i) { return !isRedoLine(i); });
        merchantCents = items.reduce(function (sum, i) { return sum + i.line_price; }, 0);
        return Promise.all(items.map(function (i) { return resolveExclusion(i.handle); })).then(
          function (excludedFlags) {
            var valid = excludedFlags.filter(function (x) { return !x; }).length;
            eligible = items.length ? valid > 0 : null;
            log("cart:", items.length, "items,", valid, "eligible ->",
              eligible === false ? "HIDE" : "SHOW");
            sync();
            updatePrice();
          },
        );
      })
      .catch(function () {});
  }

  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      try {
        sync();
      } catch (e) {
        document.documentElement.classList.remove(INJECTED_CLASS);
      }
    });
  }

  /** Variant ids out of an add-to-cart body: JSON, FormData, or urlencoded. */
  function addedVariantIds(body) {
    try {
      if (!body) return null;
      if (typeof FormData !== "undefined" && body instanceof FormData) {
        return body.get("id") ? [String(body.get("id"))] : null;
      }
      if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
        return body.get("id") ? [String(body.get("id"))] : null;
      }
      if (typeof body !== "string") return null;
      if (body.charAt(0) === "{") {
        var json = JSON.parse(body);
        if (json.items) {
          return json.items.map(function (i) { return String(i.id); });
        }
        return json.id ? [String(json.id)] : null;
      }
      var params = new URLSearchParams(body);
      return params.get("id") ? [String(params.get("id"))] : null;
    } catch (e) {
      return null;
    }
  }

  /** Show on the click, not the response. Skipped only when every added variant
   *  is one Liquid already told us is excluded. */
  function optimisticShow(body) {
    var ids = addedVariantIds(body);
    if (ids && ids.length && ids.every(function (id) {
      return cfg.excludedVariants.indexOf(id) !== -1;
    })) {
      log("add is excluded-only, not showing:", ids);
      return;
    }
    eligible = true;
    log("optimistic show on add", ids || "(body unreadable)");
    scheduleSync();
  }

  /** Rebuy writes the cart over fetch/XHR; both are hooked so any add, change,
   *  or removal re-runs eligibility. */
  function watchCartWrites() {
    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function (input, init) {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        if (CART_ADD.test(url)) optimisticShow(init && init.body);
        var promise = origFetch.apply(this, arguments);
        if (CART_WRITE.test(url)) {
          promise.then(function () { refreshCart(); }, function () {});
        }
        return promise;
      };
    }
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__redoCartAdd = CART_ADD.test(String(url));
      if (CART_WRITE.test(String(url))) {
        this.addEventListener("load", function () { refreshCart(); });
      }
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
      if (this.__redoCartAdd) optimisticShow(body);
      return origSend.apply(this, arguments);
    };
  }

  function init() {
    tpl = document.querySelector("[data-redo-instant-template]");
    if (!tpl) return;
    var meta = tpl.content.querySelector("[data-redo-instant]");
    var priceEl = tpl.content.querySelector("[data-redo-instant-price]");
    if (!meta) return;
    cfg = {
      injectAfter: tpl.getAttribute("data-inject-after"),
      handle: meta.getAttribute("data-product-handle"),
      productId: Number(meta.getAttribute("data-product-id")),
      variantId: Number(meta.getAttribute("data-variant-id")),
      nativeSelector: meta.getAttribute("data-native-selector"),
      clickSelector: meta.getAttribute("data-native-click-selector"),
      excludeTags: meta.getAttribute("data-exclude-tags") || ",",
      excludedVariants: (meta.getAttribute("data-excluded-variants") || "").split(",").filter(Boolean),
      coverageCents: Number(priceEl && priceEl.getAttribute("data-coverage-cents")),
    };
    // Liquid already resolved tags for the render-time cart and current product.
    (meta.getAttribute("data-excluded-handles") || "").split(",").filter(Boolean)
      .forEach(function (h) { verdicts[h] = true; });
    (meta.getAttribute("data-valid-handles") || "").split(",").filter(Boolean)
      .forEach(function (h) { verdicts[h] = false; });
    log("init", cfg, "seeded verdicts:", verdicts);
    watchCartWrites();
    scheduleSync();
    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true,
    });
    refreshCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function toggleModal(open) {
    var modal = document.querySelector("[data-redo-instant-modal]");
    if (!modal) return;
    if (open) {
      if (modal.showModal) modal.showModal();
      else modal.setAttribute("open", "");
    } else if (modal.close) {
      modal.close();
    } else {
      modal.removeAttribute("open");
    }
  }

  document.addEventListener("click", function (ev) {
    if (!ev.target || !ev.target.closest) return;
    if (ev.target.closest("[data-redo-instant-info]")) {
      ev.preventDefault();
      toggleModal(true);
    } else if (
      ev.target.closest("[data-redo-instant-modal-close]") ||
      ev.target.hasAttribute("data-redo-instant-modal")
    ) {
      // The dialog element itself is the backdrop area around the content.
      toggleModal(false);
    }
  });

  /** Redo's buttons show a pending state and re-enable after ~2s, so an upsell
   *  popup (which keeps the shopper on the page) can't leave ours stuck. */
  function setPending(btn, on) {
    if (!btn) return;
    if (on) {
      btn.classList.add("redo-instant--pending");
      btn.setAttribute("aria-busy", "true");
      if (!btn.querySelector(".redo-instant__spinner")) {
        var sp = document.createElement("span");
        sp.className = "redo-instant__spinner";
        btn.appendChild(sp);
      }
    } else {
      btn.classList.remove("redo-instant--pending");
      btn.removeAttribute("aria-busy");
      var el = btn.querySelector(".redo-instant__spinner");
      if (el) el.remove();
    }
  }

  function anyPending() {
    return !!document.querySelector(".redo-instant--pending");
  }

  /** Clicking Rebuy's own button keeps their checkout behaviour — upsell
   *  popups, validation, analytics — instead of jumping straight to /checkout. */
  function proceedToCheckout() {
    var native = document.querySelector(cfg.clickSelector || cfg.nativeSelector);
    if (native) {
      document.documentElement.classList.add("redo-instant--handoff");
      native.click();
    } else {
      window.location.href = "/checkout";
    }
  }

  /** Same test the app uses (isCoverageFeeProduct): our own product first, then
   *  the vendor/sku/title heuristics that catch coverage lines from a split
   *  product or an older Redo setup. */
  function isRedoLine(item) {
    if (cfg.productId && Number(item.product_id) === cfg.productId) return true;
    if (cfg.handle && item.handle === cfg.handle) return true;
    var vendor = String(item.vendor || "").toLowerCase().trim();
    var sku = String(item.sku || "").toLowerCase();
    var title = String(item.product_title || item.title || "").toLowerCase();
    return (
      /^re:?do$/.test(vendor) ||
      sku.indexOf("x-redo") === 0 ||
      title.indexOf("re:do") !== -1 ||
      title.indexOf("redo fee") !== -1
    );
  }

  /** The cart must end up with exactly one Redo line — ours, quantity 1. Stale
   *  lines (a variant Redo priced for a different cart total, a leftover from a
   *  split product) are removed, matching the widget's own reconciliation. */
  function reconcileCart(cart, optedIn) {
    var keep = null;
    var drop = [];
    var merchantItems = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!isRedoLine(item)) {
        merchantItems++;
      } else if (optedIn && !keep && item.id === cfg.variantId) {
        keep = item;
      } else {
        drop.push(item);
      }
    }
    if (drop.length) log("removing", drop.length, "stale Redo line(s)");

    var ops = drop.map(function (item) {
      return function () { return postJson("/cart/change.js", { id: item.key, quantity: 0 }); };
    });
    if (optedIn && merchantItems > 0) {
      if (!keep) {
        ops.push(function () {
          return postJson("/cart/add.js", { items: [{ id: cfg.variantId, quantity: 1 }] });
        });
      } else if (keep.quantity !== 1) {
        ops.push(function () { return postJson("/cart/change.js", { id: keep.key, quantity: 1 }); });
      }
    } else if (keep) {
      ops.push(function () { return postJson("/cart/change.js", { id: keep.key, quantity: 0 }); });
    }
    // Sequential: Shopify serialises cart writes and rejects overlapping ones.
    return ops.reduce(function (p, op) { return p.then(op); }, Promise.resolve());
  }

  function handleCheckoutClick(wrap, optedIn, onDone) {
    var done = false;
    function go() {
      if (done) return;
      done = true;
      proceedToCheckout();
      if (onDone) onDone();
    }
    // Never trap the shopper behind a failed/slow call.
    setTimeout(go, NAV_TIMEOUT_MS);

    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) { return reconcileCart(cart, optedIn); })
      .then(function () {
        return postJson("/cart/update.js", {
          attributes: {
            redo_treatment_id: wrap.getAttribute("data-treatment-id"),
            redo_opted_in_from_cart: optedIn ? "true" : "false",
            redo_metadata: JSON.stringify({ optedTimestamp: Date.now() }),
          },
        });
      })
      .then(go)
      .catch(go);
  }

  document.addEventListener(
    "click",
    function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest("[data-redo-instant-action]");
      if (!btn) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (anyPending()) return;
      try {
        var wrap = btn.closest("[data-redo-instant]");
        setPending(btn, true);
        handleCheckoutClick(wrap, btn.getAttribute("data-redo-instant-action") === "with", function () {
          setTimeout(function () { setPending(btn, false); }, PENDING_RESET_MS);
        });
      } catch (e) {
        // Fail open: unhide Rebuy's button and let the shopper through.
        document.documentElement.classList.remove(INJECTED_CLASS);
        window.location.href = "/checkout";
      }
    },
    true
  );
})();
